"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFilterRequestScope = void 0;
function createFilterRequestScope(client, _ref) {
  var _client$transport$onR, _client$transport;
  let {
    method
  } = _ref;
  const requestMap = {};
  if (client.transport.type === 'fallback') (_client$transport$onR = (_client$transport = client.transport).onResponse) === null || _client$transport$onR === void 0 || _client$transport$onR.call(_client$transport, _ref2 => {
    let {
      method: method_,
      response: id,
      status,
      transport
    } = _ref2;
    if (status === 'success' && method === method_) requestMap[id] = transport.request;
  });
  return id => requestMap[id] || client.request;
}
exports.createFilterRequestScope = createFilterRequestScope;
//# sourceMappingURL=createFilterRequestScope.js.map